import ContentClassification from "./content-classification";

export default ContentClassification;